<template>
  <div class="flex flex-col h-full bg-white p-4 font-sans">
    <header class="mb-6 px-2">
      <h2 class="text-2xl font-black text-main-900">Mensajes</h2>
      <p class="text-gray-500 text-sm">Tus conversaciones recientes</p>
    </header>

    <div class="flex-1 overflow-y-auto">
        <div v-if="loading" class="flex flex-col items-center justify-center py-20 gap-4">
            <div class="w-12 h-12 border-4 border-blue-100 border-t-blue-500 rounded-full animate-spin"></div>
            <p class="text-gray-400 font-bold text-sm uppercase tracking-widest">Cargando Mensajes...</p>
        </div>

      <div
        v-for="(chat, index) in chatHistory"
        :key="chat.id"
        class="relative"
      >
        <div
          @click="openChat(chat.id)"
          class="flex items-center gap-4 p-3 rounded-2xl hover:bg-main-50/50 cursor-pointer transition-all active:scale-95 z-10 relative"
        >
          <div class="relative">
            <img :src="chat.photo_url" class="w-14 h-14 rounded-full object-cover border-2 border-pink-100 shadow-sm" @contextmenu.prevent @click.stop/>
            <div
              class="absolute bottom-0 right-0 w-4 h-4 border-2 border-white rounded-full transition-colors duration-500"
              :class="chat.is_online == 1 ? 'bg-green-500' : 'bg-gray-400'"
            ></div>
          </div>

          <div class="flex-1 min-w-0">
            <div class="flex justify-between items-baseline">
              <h4 class="font-bold text-gray-800 truncate">{{ chat.name }}</h4>
              <span class="text-[10px] text-gray-400 font-medium">{{ formatTime(chat.last_message_time) }}</span>
            </div>
            <div class="flex justify-between items-center">
              <p class="text-sm text-gray-500 truncate pr-4">
                <template v-if="esImagen(chat.last_message)">
                    📷 Foto recibida...
                </template>
                <template v-else>
                    {{ chat.last_message }}
                </template>
              </p>
              <span v-if="chat.is_online == 0" class="text-[9px] font-black text-blue-400/70 uppercase tracking-tighter">Offline</span>
            </div>
          </div>
        </div>

        <div
          v-if="index !== chatHistory.length - 1"
          class="absolute bottom-0 right-6 left-[5.2rem] border-b border-pink-200/50"
        ></div>
      </div>

      <div v-if="!loading && chatHistory.length === 0" class="text-center py-20">
        <p class="text-gray-400 italic">No tienes chats aún.</p>
        <button @click="$router.push('/')" class="mt-4 text-pink-500 font-bold underline">Buscar Match</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/api'

const router = useRouter()
const chatHistory = ref([])
const loading = ref(true)

const fetchHistory = async () => {
  try {
    const res = await api.get('/chat_history_list')
    chatHistory.value = res.data
  } catch (err) {
    console.error(err)
  } finally {
    loading.value = false
  }
}

const formatTime = (dateStr) => {
  if (!dateStr) return '';

  // 1. Forzamos a que el string sea tratado como UTC añadiendo 'Z' al final
  // Esto evita que el navegador intente adivinar la zona horaria
  const utcDate = new Date(dateStr.replace(' ', 'T') + 'Z');

  // 2. Lo formateamos específicamente para Nicaragua
  return utcDate.toLocaleTimeString('es-NI', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'America/Managua'
  });
}
const esImagen = (texto) => {
  if (!texto) return false;
  // Detecta si es una URL de imagen común
  return texto.startsWith('http') && (texto.match(/\.(jpeg|jpg|gif|png|webp)/i));
}
const openChat = (id) => {
  router.push(`/chat/${id}`)
}

onMounted(fetchHistory)
</script>